import { getConfig } from "@src/config";
import useSearchFilter from "@src/shared/context/searchfilter/useSearchFilter";
import useSearchResult from "@src/shared/context/searchresult/useSearchResult";
import React from "react";
import { FormattedMessage, FormattedNumber, useIntl } from "react-intl";
import styled from "styled-components";

import BoxTabContent from "./BoxTabContent";
import { ResultsLink } from "./BoxTabContent.sc";
import BoxTabs from "./BoxTabs";
import { ContentWrapper, FiltersRoot } from "./Searchbox.sc";

interface SearchboxProps {
    filters: React.ReactElement;
    hasEndAdornment?: boolean;
    infoIconText?: React.ReactNode;
}

const Searchbox: React.FC<SearchboxProps> = ({ filters, hasEndAdornment, infoIconText }) => {
    const intl = useIntl();
    const filter = useSearchFilter();
    const searchResult = useSearchResult();

    return (
        <ContentWrapper
            aria-label={intl.formatMessage({ id: "leaseme.searchbox.ariaLabel", defaultMessage: "Suchfilter für Leasing und Kreditangebote" })}
        >
            <BoxTabs />
            <BoxTabContent hasEndAdornment={hasEndAdornment} infoIconText={infoIconText} />
            <FiltersRoot>{filters}</FiltersRoot>
            <AriaResultsLink to={filter.generateUrlFromFilter(filter.filter, "vehicles")}>
                <FormattedNumber value={searchResult.totalCount} />{" "}
                {getConfig("isCarhubActive") && getConfig("scope").domain === "car4me.porschebank.at" ? (
                    <FormattedMessage
                        id="leaseme.results"
                        defaultMessage="{total, plural, =1 {{single}} other {{plural}}}"
                        values={{
                            total: searchResult.totalCount,
                            single: intl.formatMessage({
                                id: "leaseme.results.slider.single",
                                defaultMessage: "Treffer anzeigen",
                            }),
                            plural: intl.formatMessage({
                                id: "leaseme.results.slider.plural",
                                defaultMessage: "Treffer anzeigen",
                            }),
                        }}
                    />
                ) : (
                    <FormattedMessage
                        id="leaseme.results"
                        defaultMessage="{total, plural, =1 {{single}} other {{plural}}}"
                        values={{
                            total: searchResult.totalCount,
                            single: intl.formatMessage({
                                id: "leaseme.results.single",
                                defaultMessage: "Treffer",
                            }),
                            plural: intl.formatMessage({
                                id: "leaseme.results.plural",
                                defaultMessage: "Treffer",
                            }),
                        }}
                    />
                )}
            </AriaResultsLink>
        </ContentWrapper>
    );
};

export default Searchbox;

const AriaResultsLink = styled(ResultsLink)`
    position: absolute;
    z-index: 500;
    display: flex;
    opacity: 0;
    text-decoration: none;
    pointer-events: none;
    justify-content: center;
    bottom: -50px;
    border: 2px solid ${({ theme }) => theme.colors.porscheBankBlue};

    /* Hide the button visually but keep it accessible for screen readers */
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    width: 1px;
    overflow: hidden;
    white-space: nowrap;

    &:focus {
        opacity: 1;
        width: 85vw;
        height: 40px;
        clip: auto;
        clip-path: none;
        outline: 1px solid ${({ theme }) => theme.colors.outlineRed};
        outline-offset: 3px;
        pointer-events: auto;
    }

    ${({ theme }) => theme.breakpoints.md.mediaquery} {
        bottom: 0;
    }
`;
